import { supabase } from '../../../shared/lib/supabaseClient';
import { logActivity } from '../../../shared/services/activityLogService';
import { teacherLoginEmail } from '../../../shared/constant/teacherLogin';
import { studentSignIn } from './studentAuthService';

export async function signIn(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) throw error;
  await logActivity('login', 'Logged in');
  return data;
}

// For anything typed without an '@': a student's username, or a teacher's username / employee ID.
// Usernames are unique across both (check_username_free in schema.sql), so at most one matches.
export async function signInWithUsername(username, password) {
  if (await studentSignIn(username, password)) return;

  const { error } = await supabase.auth.signInWithPassword({ email: teacherLoginEmail(username), password });
  if (error) throw new Error('Invalid username or password');
  await logActivity('login', 'Logged in');
}

export async function getOwnApprovalStatus() {
  const {
    data: { user },
    error: userError,
  } = await supabase.auth.getUser();
  if (userError) throw userError;

  const { data, error } = await supabase
    .from('teachers')
    .select('approved')
    .eq('email', user.email)
    .maybeSingle();
  if (error) throw error;

  return data?.approved ?? false;
}

export async function signOut() {
  await logActivity('logout', 'Logged out');
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}

export function getSession() {
  return supabase.auth.getSession();
}

export function onAuthStateChange(callback) {
  return supabase.auth.onAuthStateChange(callback);
}
